<div
  class="container h-100 layout-small"
  [ngClass]="{ 'thank-you-page-layout': showThankYouPage && isMobileView }"
>
  <div class="row h-100">
    @if(onSecondStep) {
    <div class="d-flex align-items-center p-0 position-relative">
      <h3 class="form-heading mb-0">
        GET FREE <span class="styled-heading"> & MULTIPLE QUOTES</span>
      </h3>

      <div class="modal-header position-absolute" (click)="closeModal()">
        <img src="assets/images/icons/cross-btn.svg" alt="close-btn" />
      </div>
    </div>

    <hr class="solid" style="opacity: 0.15" />
    }
    <div
      class="col-12 form-container"
      [ngClass]="{ 'thank-you-page-layout': showThankYouPage && isMobileView }"
    >
      <div class="form-section position-relative">
        <!-- <div class="">
          @if(apiError){
          <div class="error-chip px-3 py-2 ms-1 gap-2">
            <img
              src="assets/images/icons/error-icons.png"
              alt="Error"
              height="15px"
              width="15px"
            /><span>Please Try Again. There is some error occured</span>
          </div>
          }
        </div> -->
        <mat-horizontal-stepper [linear]="true" #stepper class="stepper">
          <!-- Step 1: Basic Info -->
          <mat-step [stepControl]="firstFormGroup">
            <div class="">
              @if(apiError){
              <div class="error-chip px-3 py-2 ms-1 gap-2">
                <img
                  src="assets/images/icons/error-icons.png"
                  alt="Error"
                  height="15px"
                  width="15px"
                /><span>Please Try Again. There is some error occured</span>
              </div>
              }
            </div>
            <form [formGroup]="firstFormGroup">
              <div class="form-section-wrapper">
                <ng-template matStepLabel>Basic Info</ng-template>

                <div class="row">
                  <!-- Travelling To -->
                  <div class="form-group mb-2 col-lg-6">
                    <label for="travelTo" class="label-text section-label"
                      >Travelling To
                      <span class="mandatory-star-mark">*</span></label
                    >
                    <div class="position-relative departure-date-container">
                      <ng-select
                        [bindValue]="'_id'"
                        [bindLabel]="'name'"
                        [items]="destinationsListItems"
                        class="w-100"
                        placeholder="Enter Destination"
                        [searchable]="true"
                        [typeahead]="destinationSearch$"
                        (clear)="onDestinationSearch('')"
                        (change)="onDestinationSelected($event)"
                        formControlName="to"
                        (search)="onSearch()"
                        [(ngModel)]="selectedDestination"
                      >
                      </ng-select>
                      <!-- <img class="position-absolute icon" src="assets/images/icons/down-arrow-red.svg"
                        alt="dropdown-icon" /> -->
                    </div>
                    <div
                      *ngIf="
                        firstFormGroup.get('to')?.invalid &&
                        firstFormGroup.get('to')?.touched
                      "
                      class="text-danger"
                    >
                      <small
                        class="fs-11"
                        *ngIf="firstFormGroup.get('to')?.errors?.['required']"
                      >
                        Destination is required
                      </small>
                    </div>
                  </div>

                  <div class="form-group mb-2 col-lg-6">
                    <label for="from" class="label-text section-label"
                      >From <span class="mandatory-star-mark">*</span></label
                    >
                    <div class="position-relative departure-date-container">
                      <ng-select
                        [bindValue]="'_id'"
                        [bindLabel]="'name'"
                        [items]="filteredCities$ | async"
                        [typeahead]="citySearch$"
                        [editableSearchTerm]="true"
                        [addTag]="addTagFn.bind(this)"
                        [searchable]="true"
                        class="w-100"
                        placeholder="Enter City"
                        (clear)="onCitySearch('')"
                        (change)="onCitySearch(''); cityValue($event)"
                        formControlName="from"
                      >
                      </ng-select>
                      <!-- <img class="position-absolute icon" src="assets/images/icons/down-arrow-red.svg"
                        alt="dropdown-icon" /> -->
                    </div>
                    <div
                      *ngIf="
                        firstFormGroup.get('from')?.invalid &&
                        firstFormGroup.get('from')?.touched
                      "
                      class="text-danger"
                    >
                      <small
                        class="fs-11"
                        *ngIf="firstFormGroup.get('from')?.errors?.['required']"
                        >City is required.</small
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <!-- Departure Type -->
                  <div class="form-group mb-2 col-lg-6">
                    <div class="row d-flex">
                      <div
                        class="departure-date-container"
                        [ngClass]="{
                          'col-lg-7 col-md-8 col-sm-7 col-7': departureTypeInput
                        }"
                      >
                        <label class="label-text section-label"
                          >Departure Date
                          <span class="mandatory-star-mark">*</span></label
                        >
                        <input
                          readonly
                          mat-raised-button
                          type="text"
                          class="form-control custom-input departure-date-picker"
                          placeholder="Select"
                          (click)="openDropdown($event)"
                          [value]="departureTypeInput"
                        />
                      </div>
                      <div
                        class="col-lg-5 col-md-4 col-sm-5 col-5 ps-0 departure-date-section"
                        *ngIf="departureTypeInput != ''"
                      >
                        <label class="label-text section-label"
                          >Trip Duration</label
                        >
                        <div class="input-group">
                          <mat-icon (click)="decreaseNoOfDay()"
                            >remove</mat-icon
                          >
                          <input
                            readonly
                            mat-raised-button
                            formControlName="tripDuration"
                            type="text"
                            class="form-control"
                          />
                          <mat-icon (click)="increaseNoOfDay()">add</mat-icon>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group col-lg-6 mb-2">
                    <label for="email" class="label-text section-label"
                      >Name <span class="mandatory-star-mark">*</span></label
                    >
                    <div class="departure-date-container">
                      <input
                        type="text"
                        formControlName="name"
                        class="form-control custom-input"
                        placeholder="Enter Name"
                      />
                    </div>
                    <div
                      *ngIf="
                        firstFormGroup.get('name')?.invalid &&
                        firstFormGroup.get('name')?.touched
                      "
                      class="text-danger"
                    >
                      <small
                        class="fs-11"
                        *ngIf="firstFormGroup.get('name')?.errors?.['required']"
                        >Name is required</small
                      >
                    </div>
                  </div>
                  <!-- Have you booked your flight yet -->
                  <!-- <div class="col-lg-6 departure-date-section">
                    <div class="form-group mb-2">
                      <label class="label-text mb-1">
                        {{
                          firstFormGroup.get("departureType")?.value ===
                          "flexible"
                            ? "Do you want to book a flight?*"
                            : "Have
                        you booked your flight yet?*"
                        }}
                      </label>

                      <label
                        class="label-text mb-2"
                        [innerHTML]="
                          firstFormGroup.get('departureType')?.value ===
                          'flexible'
                            ? 'Do you want to book a flight? <span class=\'mandatory-star-mark\'>*</span>'
                            : 'Have you booked your flight yet? <span class=\'mandatory-star-mark\'>*</span>'
                        "
                      >
                      </label>

                      <div
                        class="d-flex align-items-center gap-1 gap-sm-2 flight-status"
                      >
                        <ng-container
                          *ngFor="
                            let option of isFlightBookedOptions;
                            let i = index
                          "
                        >
                          <div
                            class="flight-status-btn"
                            (click)="selectFlightStatus(option.value)"
                            [ngClass]="{
                              'active status-btn': flightStatus === option.value
                            }"
                          >
                            {{ option.label }}

                            @if(flightStatus === option.value){
                            <i class="fas fa-check-circle check-icon"></i>
                            }
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div> -->
                </div>

                <!-- <div class="row">
                  <div class="col-lg-6 departure-date-section">
                    <div class="form-group mb-2 travel-planing">
                      <label class="label-text"
                        >Planning to Book
                        <span class="mandatory-star-mark">*</span></label
                      >
                      <div class="search-input-container">
                        <ng-select
                          id="custom-days"
                          [items]="travelPlans"
                          formControlName="bookingTimeFrame"
                          class="w-100 custom-days"
                          placeholder="Select Duration"
                          [searchable]="false"
                        >
                        </ng-select>
                      </div>
                      <div
                        *ngIf="
                          firstFormGroup.get('bookingTimeFrame')?.invalid &&
                          firstFormGroup.get('bookingTimeFrame')?.touched
                        "
                        class="text-danger"
                      >
                        <small
                          class="fs-11"
                          *ngIf="firstFormGroup.get('bookingTimeFrame')?.errors?.['required']"
                        >
                          Booking time is required
                        </small>
                      </div>
                    </div>
                  </div>

                  <div class="form-group col-lg-6 mb-2">
                    <label for="email" class="label-text section-label"
                      >Name <span class="mandatory-star-mark">*</span></label
                    >
                    <div class="departure-date-container">
                      <input
                        type="text"
                        formControlName="name"
                        class="form-control custom-input"
                        placeholder="Enter Name"
                      />
                    </div>
                    <div
                      *ngIf="
                        firstFormGroup.get('name')?.invalid &&
                        firstFormGroup.get('name')?.touched
                      "
                      class="text-danger"
                    >
                      <small
                        class="fs-11"
                        *ngIf="firstFormGroup.get('name')?.errors?.['required']"
                        >Name is required</small
                      >
                    </div>
                  </div>
                </div> -->

                <div class="row">
                  <div class="form-group col-lg-6 mb-2">
                    <div class="mb-2">
                      <label for="mobile" class="label-text section-label"
                        >Mobile Number
                        <span class="mandatory-star-mark">*</span></label
                      >
                      <div
                        class="d-flex gap-1 align-items-center departure-date-container"
                      >
                        <ng-select
                          [items]="countryCodes"
                          class="custom-country-code-selector no-icon"
                          [searchable]="false"
                          formControlName="countryCode"
                        ></ng-select>

                        <input
                          type="text"
                          formControlName="phone"
                          class="form-control custom-input"
                          placeholder="Enter Number"
                          appOnlyNumbers
                        />
                      </div>
                      <div
                        *ngIf="
                          firstFormGroup.get('phone')?.invalid &&
                          firstFormGroup.get('phone')?.touched
                        "
                        class="text-danger"
                      >
                        <small
                          class="fs-11"
                          *ngIf="firstFormGroup.get('phone')?.errors?.['required']"
                        >
                          Mobile number is required
                        </small>

                        <small
                          class="fs-11"
                          *ngIf="
                          !firstFormGroup.get('phone')?.errors?.['required'] &&
                          firstFormGroup.get('phone')?.errors?.['minlength']
                        "
                        >
                          Mobile number must be exactly 10 digits long
                        </small>

                        <small
                          class="fs-11"
                          *ngIf="
                          !firstFormGroup.get('phone')?.errors?.['required'] &&
                          !firstFormGroup.get('phone')?.errors?.['minlength'] &&
                          firstFormGroup.get('phone')?.errors?.['maxlength']
                        "
                        >
                          Mobile number must be exactly 10 digits long
                        </small>

                        <small
                          class="fs-11"
                          *ngIf="
                          !firstFormGroup.get('phone')?.errors?.['required'] &&
                          !firstFormGroup.get('phone')?.errors?.['minlength'] &&
                          !firstFormGroup.get('phone')?.errors?.['maxlength'] &&
                          firstFormGroup.get('phone')?.errors?.['pattern']
                        "
                        >
                          Mobile number must start with 6, 7, 8, or 9
                        </small>
                      </div>
                    </div>
                  </div>

                  <div class="form-group col-lg-6 mb-2">
                    <label for="email" class="label-text section-label"
                      >Email ID
                      <span class="mandatory-star-mark">*</span></label
                    >
                    <div class="departure-date-container">
                      <input
                        type="email"
                        formControlName="email"
                        class="form-control custom-input"
                        placeholder="Enter Email Address"
                      />
                    </div>
                    <div
                      *ngIf="
                        firstFormGroup.get('email')?.invalid &&
                        firstFormGroup.get('email')?.touched
                      "
                      class="text-danger"
                    >
                      <small
                        class="fs-11"
                        *ngIf="firstFormGroup.get('email')?.errors?.['required']"
                        >Email is required</small
                      >
                      <small
                        class="fs-11"
                        *ngIf="firstFormGroup.get('email')?.errors?.['pattern']"
                        >Please enter a valid email address</small
                      >
                    </div>
                  </div>

                  <!-- Who is Travelling -->
                  <div class="form-group col-lg-6 mb-2">
                    <div class="mb-2">
                      <label class="label-text section-label"
                        >Who is Travelling?</label
                      >
                      <div class="departure-date-container">
                        <input
                          readonly
                          mat-raised-button
                          (click)="openAdultsDropdown($event)"
                          type="text"
                          class="form-control custom-input sheet-btn travellers-input"
                          placeholder="Rooms | Adults | Children | Infant"
                          [value]="
                            coTravellerDynamicPlaceholder
                              ? coTravellerDynamicPlaceholder
                              : null
                          "
                        />
                      </div>
                      <!-- <div class="departure-date-container">
                        <input
                          readonly
                          mat-raised-button
                          (click)="openAdultsDropdown($event)"
                          type="text"
                          class="form-control custom-input sheet-btn travellers-input"
                          placeholder="Adults | Children | Infant"
                          [value]="
                            dynamicPlaceholder ? dynamicPlaceholder : null
                          "
                        />
                      </div> -->
                    </div>
                    <div
                      class="whatsapp-checkbox-container d-flex mb-0 mb-md-2"
                    >
                      <input
                        type="checkbox"
                        id="whatsapp"
                        class="custom-checkbox checkbox-container me-2"
                        formControlName="sendUpdatesViaWhatsApp"
                      />
                      <label
                        class="checkbox-label d-flex"
                        for="whatsapp"
                        (click)="toggleWhatsAppSelection()"
                      >
                        <i
                          class="fab fa-whatsapp me-1 fs-14"
                          style="color: #25d366"
                        ></i>

                        I want to receive trip details and offers on WhatsApp.
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <div
              class="d-flex w-100 align-items-center apply-button-container gap-3"
            >
              <div class="Secure-strip position-relative">
                <p class="m-0 fs-12 fw-medium">
                  100% Privacy with No Spam Calls, Only Relevant Offers
                </p>
                <img
                  class="position-absolute lead-lock-icon"
                  src="assets/images/icons/lead-lock.svg"
                  alt="lock"
                />
              </div>

              <div class="trip-plan-button">
                <app-button
                  class="my-md-3 my-lg-4"
                  type="primary"
                  [appButtonLoader]="isSubmitting"
                  (click)="planMyTrip(stepper)"
                  [disabled]="firstFormGroup.invalid"
                  [actionType]="'submit'"
                >
                  <div
                    class="d-flex justify-content-center align-items-center gap-1"
                  >
                    Plan My Trip<mat-icon>chevron_right</mat-icon>
                  </div>
                </app-button>
              </div>
            </div>
          </mat-step>

          <!-- Step 2: Travel Info & Finalize -->
          <mat-step [stepControl]="secondFormGroup">
            <form [formGroup]="secondFormGroup" *ngIf="!showThankYouPage">
              <ng-template matStepLabel>Travel Info & Finalize</ng-template>
              <div
                class="modal-header position-absolute"
                (click)="closeModal()"
              >
                <img src="assets/images/icons/cross-btn.svg" alt="close-btn" />
              </div>

              <div class="first-step-info my-3 mt-4">
                <div class="d-flex gap-2 align-items-center">
                  <img
                    src="/assets/images/icons/snackbar-tick-icon.png"
                    alt="icon"
                    class="checked-icon"
                  />
                  <p class="message mb-0">
                    Okay {{ leadName }}, we will contact you on
                    {{ leadPhone }} and {{ leadEmail }}
                  </p>
                </div>
              </div>
              <p class="more-info-head fw-medium fs-12 mt-2">
                Tell us more about your travel needs
              </p>

              <div class="form-section-wrapper-second">
                <div class="form-group mb-3">
                  <label class="label-text section-label"
                    >Have you booked your flight yet?</label
                  >

                  <div class="row">
                    <div
                      class="btn-group col-md-12 d-flex justify-content-between gap-3 flex-wrap small-screen-spacing"
                    >
                      <div
                        *ngFor="let option of isFlightBookedOptions"
                        [ngClass]="{
                          'active status-btn': flightStatus === option.value
                        }"
                        (click)="selectFlightStatus(option.value)"
                        class="btn position-relative"
                      >
                        <div class="rating-box">
                          {{ option.label }}
                          <i
                            *ngIf="flightStatus === option.value"
                            class="fas fa-check-circle check-icon position-absolute checkmark"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-3">
                  <label class="label-text section-label"
                    >Planning to Book</label
                  >

                  <div class="row">
                    <div
                      class="btn-group col-md-12 d-flex justify-content-between gap-3 flex-wrap small-screen-spacing"
                    >
                      <div
                        *ngFor="let option of travelPlans"
                        [ngClass]="{
                          'active status-btn': planningToBook === option.plan
                        }"
                        (click)="selectPlanningToBookStatus(option.plan)"
                        class="btn position-relative"
                      >
                        <div class="rating-box">
                          {{ option.label }}
                          <i
                            *ngIf="planningToBook === option.plan"
                            class="fas fa-check-circle check-icon position-absolute checkmark"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Hotel Category -->
                <div class="form-group mb-3">
                  <label class="label-text section-label">Hotel Category</label>
                  <div class="row">
                    <div
                      class="btn-group col-md-12 d-flex justify-content-between gap-3 flex-wrap small-screen-spacing"
                    >
                      <div
                        *ngFor="let option of hotelCategories"
                        [ngClass]="{
                          active: selectedHotelCategory === option.category
                        }"
                        (click)="selectHotelCategory(option.category)"
                        class="btn position-relative"
                      >
                        <div class="rating-box">
                          <i
                            class="fas far fa-star"
                            [ngClass]="{
                              selected:
                                selectedHotelCategory === option.category
                            }"
                            [ngClass]="
                              selectedHotelCategory === option.category
                                ? 'selected'
                                : 'opacity'
                            "
                          ></i>

                          {{ option.label }}
                          <i
                            *ngIf="selectedHotelCategory === option.category"
                            class="fas fa-check-circle check-icon position-absolute checkmark"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Type of Holiday -->
                <div class="form-group mb-3">
                  <label class="label-text section-label"
                    >Type of Holiday</label
                  >
                  <div class="row">
                    <div
                      class="btn-group col-md-12 d-flex justify-content-between gap-3 flex-wrap small-screen-spacing"
                    >
                      <div
                        *ngFor="let holiday of holidayTypes"
                        [ngClass]="{
                          active: selectedHolidayType === holiday.type
                        }"
                        (click)="selectHolidayType(holiday.type)"
                        class="btn position-relative"
                      >
                        <div class="rating-box">
                          {{ holiday.label }}
                          <i
                            *ngIf="selectedHolidayType === holiday.type"
                            class="fas fa-check-circle check-icon position-absolute checkmark"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-3 form-extra-padding">
                  <label class="label-text section-label"
                    >Any Additional Request</label
                  >
                  <textarea
                    formControlName="additionalInfo"
                    class="form-control"
                    placeholder="Eg: For our honeymoon trip, please arrange a bouquet of flowers."
                  ></textarea>
                </div>
              </div>

              <div class="Secure-strip Secure-strip-second-mobile">
                <p class="m-0 fs-12 fw-medium">
                  Expert Advice with Reliable Travel Insights
                </p>
              </div>
              <div
                class="d-flex justify-content-between gap-2 my-4 form-extra-padding"
              >
                <button
                  class="btn btn-danger text-white fs-14 w-25 back-btn"
                  mat-button
                  (click)="goBack(stepper)"
                >
                  <img
                    class="btn-arrow-right back-icon"
                    src="assets/images/icons/back-arrow.svg"
                    alt="white-arrow"
                  />
                  Back
                </button>

                <div class="Secure-strip position-relative Secure-strip-second">
                  <p class="m-0 fs-12 fw-medium">
                    Expert Advice with Reliable Travel Insights
                  </p>
                  <img
                    class="position-absolute achievement-icon"
                    src="assets/images/icons/achievement.svg"
                    alt="lock"
                  />
                </div>

                <app-button
                  class="sb-second-btn"
                  type="primary"
                  [appButtonLoader]="isSubmitting"
                  (click)="onSubmit()"
                  [actionType]="'submit'"
                >
                  Submit
                  <img
                    class="btn-arrow-right submit-icon"
                    src="assets/images/icons/btn-arrow-white.svg"
                    alt="white-arrow"
                  />
                </app-button>
              </div>
            </form>
          </mat-step>
        </mat-horizontal-stepper>

        <div *ngIf="showThankYouPage && isMobileView" class="p-0">
          <div class="col-12 p-0">
            <app-lead-form-thank-you
              [data]="leadData"
              (closeLeadForm)="closeModal()"
            ></app-lead-form-thank-you>
          </div>
        </div>
      </div>

      <!-- Dropdown Component -->
      @if(isDropdownVisible){
      <div
        class="date-dropdown"
        (click)="$event.stopPropagation()"
        [ngStyle]="{
          top: dropdownPosition.top,
          left: dropdownPosition.left,
          'max-height': dropdownPosition.maxHeight,
          'max-width': dropdownPosition.maxWidth,
          'overflow-y': dropdownPosition.overflowY
        }"
      >
        <ng-container [ngTemplateOutlet]="bottomSheetTemplate"></ng-container>
      </div>
      } @if(isAdultsDropdownVisible){
      <div
        class="travel-section-container"
        (click)="$event.stopPropagation()"
        [ngStyle]="{
          top: dropdownPosition.top,
          left: dropdownPosition.left,
          'max-height': dropdownPosition.maxHeight,
          'max-width': dropdownPosition.maxWidth,
          'overflow-y': dropdownPosition.overflowY
        }"
      >
        <ng-container
          [ngTemplateOutlet]="bottomSheetTravellerTemplate"
        ></ng-container>
      </div>
      }
    </div>

    <div *ngIf="showThankYouPage && !isMobileView" class="p-0">
      <div class="col-12 p-0">
        <app-lead-form-thank-you
          [data]="leadData"
          (closeLeadForm)="closeModal()"
        ></app-lead-form-thank-you>
      </div>
    </div>
  </div>
  <ng-template #bottomSheetTemplate>
    <!-- @if(isMobileView){
    <div class="row py-2 w-100">
      <div class="col d-flex gap-2 bottomsheet-title">
        <mat-icon (click)="closeBottomSheet()">chevron_left</mat-icon>
        <span>Departure Date</span>
      </div>
      <mat-divider class="mt-2"></mat-divider>
    </div>
    } -->
    <!-- <app-departure-modal-web
      [selectedValue]="selectedValue"
      [tripDuration]="firstFormGroup.get('tripDuration')?.value"
      (selectionChange)="onSelectionChange($event)"
      [viewMode]="isMobileView ? 'single' : 'dual'"
    >
    </app-departure-modal-web> -->
    <app-dual-calendar
      calendarMode="single"
      [minDate]="today"
      (dateRangeSelected)="onSelectionChange($event)"
    >
    </app-dual-calendar>
  </ng-template>

  <ng-template #bottomSheetTravellerTemplate>
    @if(isMobileView){
    <div class="row p-2">
      <div class="col d-flex gap-2 bottomsheet-title">
        <mat-icon (click)="closeBottomSheet()">chevron_left</mat-icon>
        <span>Select Travellers</span>
      </div>
      <mat-divider class="mt-2"></mat-divider>
    </div>
    }
    <div
      class="d-grid travel-section p-3 p-md-4"
      [ngClass]="{ 'travel-section-shadow': isMobileView }"
    >
      @if(isMobileView){
      <div
        class="d-flex justify-content-between align-items-center travellers-select-container mb-3 mt-0"
      >
        <label class="fw-medium fs-16 label-counter"
          >Add Number of Travellers</label
        >
      </div>
      }
      <app-lead-travellers-modal
        [adultsCount]="firstFormGroup.get('adults')?.value || 0"
        [childrenCount]="firstFormGroup.get('child')?.value || 0"
        [infantsCount]="firstFormGroup.get('infant')?.value || 0"
        [isTravellerApplyEnabled]="firstFormGroup.get('adults')?.value > 0"
        (applyTravellers)="applyTravellerChanges($event)"
        class="leads-travellers-modal"
      ></app-lead-travellers-modal>
    </div>
  </ng-template>
</div>
